import type { InsuranceStatusQuoteFormInput } from 'app/home/create-quote/forms/insurance-status/insurance-status.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function insuranceStatusQuoteFormSelector(store: QuoteDraftSelectorState): InsuranceStatusQuoteFormInput {
  const insuranceStatus = store.insuranceStatus();
  return { insuranceStatus };
}

export function insuranceStatusQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['insurance-status']();
}
